<template>
    <div class="slide">
        <template v-if="image.video">
            <video id="video" muted loop autoplay playsinline>
                <source :src="image.video" type="video/mp4" />
            </video>
        </template>
        <template v-else>
            <!-- <img :src="getDummyImage(image).thumbnail_big" loading="lazy" class="dummy" -->
            <!--     :width="getDummyImage(image).width_big" :height="getDummyImage(image).height_big"> -->
            <!-- <img v-if="getDummyImage(image).is_paired_with_next" :src="getNextImage(getDummyImage(image)).thumbnail_big" -->
            <!--     loading="lazy" class="dummy" :width="getNextImage(getDummyImage(image)).width_big" -->
            <!--     :height="getNextImage(getDummyImage(image)).height_big"> -->
            <!-- <img v-if="getDummyImage(image).is_paired_with_next && getNextImage(getDummyImage(image)).is_paired_with_next" -->
            <!--     :src="getNextImage(getNextImage(getDummyImage(image))).thumbnail_big" loading="lazy" class="dummy" -->
            <!--     :width="getNextImage(getNextImage(getDummyImage(image))).width_big" -->
            <!--     :height="getNextImage(getNextImage(getDummyImage(image))).height_big"> -->

            <!-- <img :src="image.image.endsWith('gif') ? image.image : image.thumbnail_big" -->
            <!--     loading="lazy" :class="getClasses(image)" :width="image.width_big" :height="image.height_big"> -->

            <div class="imageContainer">
                <img
                    :src="
                        image.image.endsWith('gif')
                            ? image.image
                            : image.thumbnail_big
                    "
                    loading="lazy"
                    :class="getClasses(image)"
                />
            </div>
        </template>
        <template v-if="image.is_paired_with_next">
            <!-- <img :src="getNextImage(image).thumbnail_big" loading="lazy" :class="getClasses(image)" -->
            <!--     :width="getNextImage(image).width_big" :height="getNextImage(image).height_big"> -->
            <div class="imageContainer">
                <img
                    :src="
                        getNextImage(image).image.endsWith('gif')
                            ? getNextImage(image).image
                            : getNextImage(image).thumbnail_big
                    "
                    loading="lazy"
                    :class="getClasses(image)"
                />
            </div>
        </template>
        <template
            v-if="
                image.is_paired_with_next &&
                    getNextImage(image).is_paired_with_next
            "
        >
            <div class="imageContainer">
                <img
                    :src="
                        getNextImage(getNextImage(image)).image.endsWith('gif')
                            ? getNextImage(getNextImage(image)).image
                            : getNextImage(getNextImage(image)).thumbnail_big
                    "
                    loading="lazy"
                    :class="getClasses(image)"
                />
            </div>
        </template>
    </div>
</template>
<script>
import { store } from "@/centralStore";
export default {
    name: "SwipeImage",
    props: ["image"],
    data() {
        return {
            store: store.state
        };
    },
    methods: {
        getSrcSet(image) {
            let imageStringMed = image.thumbnail_med;
            let imageStringBig = image.thumbnail_big;
            return imageStringMed + " 900w, " + imageStringBig + " 2500w";
        },

        getNextImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 1];
        },
        getDummyImage(image) {
            let swipeImagesIdx = this.store.swipeImages.findIndex(
                i => i.id == image.id
            );
            if (swipeImagesIdx < this.store.swipeImages.length - 1) {
                return this.store.swipeImages[swipeImagesIdx + 1];
            } else {
                return this.store.swipeImages[0];
            }
        },
        getClasses(image) {
            return {
                websiteImage: image.is_website,
                lightBorder: image.border == "LI",
                darkBorder: image.border == "DA"
            };
        }
    }
};
</script>

<style scoped>
.slide {
    /* display: flex; */
    /* flex-direction: column; */
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    gap: 1rem;
    box-sizing: border-box;
    padding: 0 1rem;
}

/* #imageContainer { */
/*     display: flex; */
/*     justify-content: center; */
/*     align-items: center; */
/*     max-height: 100%; */
/*     width: 100%; */
/*     height: 100%; */
/*     gap: 1rem; */
/* } */

#imageContainer.gap {
}

.flexImages {
    height: 100%;
    width: 100%;
}

.imageContainer {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    /* width: 100%; */
    height: 100%;
}
img,
video {
    max-width: 100%;
    max-height: 100%;
    display: block;
    /* margin: auto; */
    min-width: 0;
    min-height: 0;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
}

.dummy {
    width: 1px;
    height: 1px;
    opacity: 0.01%;
    position: absolute;
    top: 0;
    left: 0;
}

.lightBorder {
    border: 0.5px solid #565656;
    box-sizing: border-box;
}

.darkBorder {
    border: 0.5px solid #202020;
    box-sizing: border-box;
}

.websiteImage {
    border-radius: 0.4rem;
}

@media screen and (min-width: 768px) {
    .lightBorder {
        border: 1px solid #565656;
        box-sizing: border-box;
    }

    .darkBorder {
        border: 1px solid #202020;
        box-sizing: border-box;
    }
}
</style>
